import React, { useEffect, useState } from 'react';
import { appsAdvApiRouterListFeaturedContent, FeaturedContentOut } from '@/lib/api';
import MediaCard from '@/components/ui-custom/MediaCard';
import { Skeleton } from '@/components/ui/skeleton';

const FeaturedContent = () => {
  const [featuredItems, setFeaturedItems] = useState<FeaturedContentOut[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedContent = async () => {
      try {
        setLoading(true);
        const response = await appsAdvApiRouterListFeaturedContent();
        setFeaturedItems(response.data.filter((item: FeaturedContentOut) => item.featured));
      } catch (error) {
        console.error('Error fetching featured content:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedContent();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array(6).fill(0).map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="w-full aspect-video rounded-lg" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        ))}
      </div>
    );
  }

  if (featuredItems.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-adv-lightGray">No featured content available.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {featuredItems.map((item) => (
        <MediaCard
          key={item.id}
          id={item.id}
          title={item.title}
          image={item.thumbnail_url}
          type={item.content_type as "article" | "video"}
          date={item.source}
          link={item.url}
          featured={true}
        />
      ))}
    </div>
  );
};

export default FeaturedContent;
